import { ResourceType } from "types/resource.service";
import { AssistantResourceService } from "./assistantResource.service";

class DealAssistantService extends AssistantResourceService {
  resourceType = "fund" as ResourceType;
}

export default new DealAssistantService();
